import type { AppState, GetterClass } from '../../../models'

export class PlayedAnimationsGetter implements GetterClass {
  static execute(this: void, state: AppState): string[] {
    return state.playedAnimations
  }
}
